var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "svg",
      {
        staticClass: "icon",
        attrs: {
          t: "1690261669565",
          viewBox: "0 0 1024 1024",
          version: "1.1",
          xmlns: "http://www.w3.org/2000/svg",
          "p-id": "42623",
          "xmlns:xlink": "http://www.w3.org/1999/xlink",
          width: _vm.size,
          height: _vm.size
        }
      },
      [
        _c("path", {
          attrs: {
            d:
              "M911.786667 493.312c-40.789333 208.896-254.933333 355.626667-345.088 409.045333a107.434667 107.434667 0 0 1-109.397334 0c-90.197333-53.418667-304.341333-200.106667-345.088-409.045333-17.024-87.338667 6.144-179.925333 61.994667-247.765333C225.322667 183.466667 296.362667 149.333333 374.314667 149.333333c48.981333 0 96.298667 12.416 137.685333 36.010667a277.461333 277.461333 0 0 1 137.728-36.010667c77.909333 0 148.949333 34.133333 200.106667 96.213334 55.765333 67.84 78.933333 160.426667 61.909333 247.765333z",
            fill: "#FF3D3F",
            "p-id": "42624"
          }
        }),
        _c("path", {
          attrs: {
            d:
              "M849.792 245.546667a297.984 297.984 0 0 1 61.013333 128.256L411.221333 873.429333c-48.213333-32.128-109.482667-78.549333-164.522666-137.386666L790.912 192c21.632 14.421333 41.386667 32.384 58.88 53.589333z",
            fill: "#FF5052",
            "p-id": "42625"
          }
        }),
        _c("path", {
          attrs: {
            d:
              "M649.728 149.333333c51.285333 0 99.584 14.805333 141.226667 42.624L246.741333 736.128c-48.725333-52.053333-92.544-113.749333-118.058666-183.722667l372.821333-372.736c3.541333 1.834667 6.997333 3.712 10.453333 5.674667a277.461333 277.461333 0 0 1 137.728-36.010667z",
            fill: "#FF6365",
            "p-id": "42626"
          }
        }),
        _c("path", {
          attrs: {
            d:
              "M374.272 149.333333c44.970667 0 88.448 10.410667 127.274667 30.336l-372.778667 372.778667a391.253333 391.253333 0 0 1-16.554667-59.136c-17.024-87.338667 6.144-179.925333 61.994667-247.765333C225.322667 183.466667 296.362667 149.333333 374.314667 149.333333z",
            fill: "#FF8A8B",
            "p-id": "42627"
          }
        })
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3731f040", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3731f040","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/icons/play_control/thumbsUp.vue
// module id = null
// module chunks = 